import { InsuranceDetails } from 'Api/insurance';
import { DateString } from 'Types/date.types';
import { isMigratedDanskeBankAgreement } from 'Utils/agreementCodes/agreementCodes.utils';
import { getPreviousDayDate } from 'Utils/date/date.utils';
import { getAppText } from 'Utils/text';

export const getCancellationAlertTexts = (
  insurance: InsuranceDetails,
  detailCwpToggle: boolean,
): { alertTitle: string; alertDescription: string } => {
  const { detailsCwp } = insurance;

  const cancelDate = detailCwpToggle
    ? detailsCwp.dates.cancellationDate
    : insurance.cancellationDate;

  const migratedDanskeBankAgreement = isMigratedDanskeBankAgreement(
    detailsCwp.agreementCode,
  );
  const alertTitle = getAppText('detailed.alert.underCancellation.title');

  const auroraAlertDescription = getAppText(
    'detailed.alert.underCancellation.aurora.content',
  );

  const defaultAlertDescription = getAppText(
    'detailed.alert.underCancellation.content',
    {
      insert: {
        cancelDate: getPreviousDayDate(cancelDate as DateString),
      },
    },
  );

  const alertDescription = migratedDanskeBankAgreement
    ? auroraAlertDescription
    : defaultAlertDescription;

  return { alertTitle, alertDescription };
};
